const routes = [
  {
    path: "/finance/consolidation",
    name: "financial-consolidation-report",
    component: () => import("@/views/finance/ConsolidationReport"),
    meta: {
      layout: "content",
      resource: "finance",
      action: "manage",
    },
  },
  {
    path: "/finance/list-consolidated-ca",
    name: "finance-list-site-ca",
    component: () => import("@/views/finance/SiteConsolidatedCa"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/finance/upload-consolidated-ca",
    name: "finance-set-site-ca",
    component: () => import("@/views/finance/UploadSiteConsolidatedCa"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  // Mappings :
  {
    path: "/finance/mapping/create",
    name: "finance-create-mapping",
    component: () => import("@/views/finance/mapping/CreateOrUpdate"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/finance/mapping/edit/:id?",
    name: "finance-edit-mapping",
    component: () => import("@/views/finance/mapping/CreateOrUpdate"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/finance/mapping/list",
    name: "finance-list-mapping",
    component: () => import("@/views/finance/mapping/List"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
];

export default routes;
